import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import {
  CampaignAutomationSettings,
  CampaignAutomationSettingsRequest,
  CampaignChannel
} from "../models/campaign-automation-settings.model";

/**
 * PURPOSE: reads/updates the consumer referral follow-up campaign automation settings, shared by the
 * Consumer Email Campaign and Consumer SMS Campaign admin screens.
 */
@Injectable({
  providedIn: "root"
})
export class CampaignAutomationSettingsService {
  constructor(private http: HttpClient) {}

  getSettings(channel: CampaignChannel): Observable<CampaignAutomationSettings> {
    return this.http
      .get<CampaignAutomationSettings>(
        `${environment.fulcrumUrl}/api/v3/campaign-automation-settings/${channel}`,
        this.buildBasicHttpOptions()
      )
      .pipe(
        catchError((error: HttpErrorResponse): Observable<never> => {
          console.error(`Error fetching ${channel} campaign automation settings:`, error);
          return throwError(() => error);
        })
      );
  }

  updateSettings(
    channel: CampaignChannel,
    request: CampaignAutomationSettingsRequest
  ): Observable<CampaignAutomationSettings> {
    return this.http
      .post<CampaignAutomationSettings>(
        `${environment.fulcrumUrl}/api/v3/campaign-automation-settings/${channel}`,
        request,
        this.buildBasicHttpOptions()
      )
      .pipe(
        catchError((error: HttpErrorResponse): Observable<never> => {
          console.error(`Error updating ${channel} campaign automation settings:`, error);
          return throwError(() => error);
        })
      );
  }

  private buildBasicHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(`${environment.claimItApiUsername}:${environment.claimItApiPassword}`)
      })
    };
  }
}
